import React from 'react';
import { Link } from 'react-router-dom';
import './BridgeClubLegal.css';

const BridgeClubTerms: React.FC = () => {
  return (
    <div className="bridge-club-legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <Link to="/bridge-club" className="back-link">
            &larr; Back
          </Link>
          <img src="/rbf-logo.png" alt="Red Bridge Farm Feed Co." className="legal-logo" />
        </div>

        <h1>Terms of Service</h1>
        <p className="legal-effective">Effective Date: January 1, 2025</p>
        <p className="legal-version">Version 1.0</p>

        <div className="legal-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By creating a Bridge Club account or using our services, you agree to be bound by these
              Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
            </p>
            <p>
              Bridge Club is a loyalty and farm management program operated by Red Bridge Farm Feed Co.
              ("Red Bridge," "we," "us," or "our").
            </p>
          </section>

          <section>
            <h2>2. Eligibility</h2>
            <p>
              To use Bridge Club, you must be at least 18 years old and capable of forming a binding contract.
              By using our services, you represent that you meet these requirements.
            </p>
          </section>

          <section>
            <h2>3. Account Registration</h2>
            <p>When you create an account, you agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Keep your login credentials secure and confidential</li>
              <li>Notify us immediately of any unauthorized access to your account</li>
              <li>Accept responsibility for all activities that occur under your account</li>
            </ul>
          </section>

          <section>
            <h2>4. Loyalty Program</h2>
            <p>
              The Bridge Club loyalty program ("Buy 10, Get 1 Free") is subject to the following conditions:
            </p>
            <ul>
              <li>Only purchases of Red Bridge brand products qualify for loyalty rewards</li>
              <li>Rewards must be redeemed at participating retail partner locations</li>
              <li>Rewards expire 30 days after issuance</li>
              <li>Rewards have no cash value and cannot be transferred</li>
              <li>We reserve the right to modify or discontinue the loyalty program at any time</li>
              <li>Fraudulent activity will result in account termination and forfeiture of rewards</li>
            </ul>
          </section>

          <section>
            <h2>5. Receipt Scanning</h2>
            <p>When you scan receipts:</p>
            <ul>
              <li>You certify that the receipt represents your own legitimate purchase</li>
              <li>Each receipt may only be scanned once across all accounts</li>
              <li>Submitting duplicate or fraudulent receipts is prohibited</li>
              <li>We use automated systems to detect and prevent fraud</li>
            </ul>
          </section>

          <section>
            <h2>6. Farm Challenge Program</h2>
            <p>
              The Farm Challenge program is optional and requires separate enrollment. By participating,
              you agree to provide accurate data about your animals and farming practices. Points earned
              through Farm Challenge are subject to separate terms and conditions.
            </p>
          </section>

          <section>
            <h2>7. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any unlawful purpose</li>
              <li>Submit false or misleading information</li>
              <li>Attempt to manipulate the loyalty or rewards systems</li>
              <li>Share your account with others</li>
              <li>Interfere with or disrupt the service</li>
              <li>Attempt to gain unauthorized access to our systems</li>
            </ul>
          </section>

          <section>
            <h2>8. Intellectual Property</h2>
            <p>
              All content, features, and functionality of Bridge Club are owned by Red Bridge Farm Feed Co.
              and are protected by copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2>9. Disclaimer of Warranties</h2>
            <p>
              Bridge Club is provided "as is" without warranties of any kind. We do not warrant that
              the service will be uninterrupted, secure, or error-free. Feeding recommendations are
              provided for informational purposes only and should not replace professional veterinary advice.
            </p>
          </section>

          <section>
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Red Bridge Farm Feed Co. shall not be liable for
              any indirect, incidental, special, consequential, or punitive damages arising from your
              use of the service.
            </p>
          </section>

          <section>
            <h2>11. Termination</h2>
            <p>
              We may suspend or terminate your account at any time for violation of these Terms. You may
              close your account at any time by contacting us. Upon termination, any unredeemed rewards
              will be forfeited.
            </p>
          </section>

          <section>
            <h2>12. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. We will notify you of significant changes
              via email or through the app. Continued use after changes constitutes acceptance of the
              new Terms.
            </p>
          </section>

          <section>
            <h2>13. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Washington, without regard to
              conflict of law principles.
            </p>
          </section>

          <section>
            <h2>14. Contact Us</h2>
            <p>
              If you have questions about these Terms, please contact us at:
            </p>
            <address>
              Red Bridge Farm Feed Co.<br />
              145 W 3rd Ave, Kettle Falls, WA 99141<br />
              Email: info@theredbridgefarm.com<br />
              Phone: (509) 738-9004
            </address>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/bridge-club/privacy" className="legal-link">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BridgeClubTerms;
